import { render, staticRenderFns } from "./BaseFormInput.vue?vue&type=template&id=0c5c8fdc&scoped=true"
import script from "./BaseFormInput.vue?vue&type=script&lang=ts"
export * from "./BaseFormInput.vue?vue&type=script&lang=ts"
import style0 from "./BaseFormInput.vue?vue&type=style&index=0&id=0c5c8fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_clean-css_2948e68b94b5de989bd17d5ad2285242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c8fdc",
  null
  
)

export default component.exports